import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalTitle: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.modal-title',
		defaultMessage: 'Help center URL update',
		description: 'Title for help center URL update modal',
	},
	modalDescription: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.modal-description',
		defaultMessage:
			"We'll redirect the default help center URL and portal URLs to improve your customers' portal experience. Your project's email addresses won't be affected and will continue to receive and send emails as usual.",
		description: 'Description for custom domain change boarding modal',
	},
	newUrl: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.new-url',
		defaultMessage: 'ACTIVE',
		description: "Lozenge of help center's custom domain URL",
	},
	customDomainUrlLabel: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.custom-domain-url-label',
		defaultMessage: 'Custom domain URL',
		description: "Label of help center's custom domain URL",
	},
	defaultUrlLabel: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.default-url-label',
		defaultMessage: 'Default URL',
		description: "Label of help center's default URL",
	},
	acknowledgeUpdateButton: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.acknowledge-update-button',
		defaultMessage: 'Got it',
		description: 'Button to acknowledge the update and close the dialog',
	},
	linkLearnMoreCustomDomain: {
		id: 'help-center-custom-domain-change-boarding.url-update-dialog.link-learn-more-custom-domain',
		defaultMessage: 'Learn more about configuring custom URLs for your Atlassian products',
		description: 'Link of how to configure custom URLs for your Atlassian products',
	},
});
